import {Component, OnInit} from '@angular/core';
import {AlertService, UserService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {VatRateService} from "../services/vatRate.service";
import {CountryService} from "../services/country.service";
import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

@Component({
    templateUrl: './vatRateForm.component.html',
    styleUrls: ['./vatRateForm.component.scss']
})

export class VatRateFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    countries: any[];

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private alertService: AlertService,
        private vatRateService: VatRateService,
        private countryService: CountryService,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        this.translationLoader.loadTranslations(polish);
    }

    ngOnInit() {
        this.countryService.getAll().subscribe((res: any[]) => {
            this.countries = res;
        }, error => {
            this.alertService.error(error);
        })

        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        this.form = this.formBuilder.group({
            country: ['', Validators.required],
            vatName: ['', Validators.required],
            vatValue: ['', Validators.required],
        });

        if (!this.isAddMode) {
            this.vatRateService.getById(this.id)
                .pipe(first())
                .subscribe(x => {
                    let countryId = null;
                    if (typeof x.country !== 'undefined') {
                        countryId = x.country.id;
                    }
                    this.f.country.setValue(countryId);
                    this.f.vatName.setValue(x.vatName);
                    this.f.vatValue.setValue(x.vatValue);
                }, error => {
                    this.alertService.error(error);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createVatRate();
        } else {
            this.updateVatRate();
        }
    }

    public onCheckboxChangeFn(event) {
        console.log(event);
    }

    private createVatRate() {
        this.vatRateService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Vat rate added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updateVatRate() {
        this.vatRateService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
